<template>
    <div v-if="error != null"> 
        <div v-if="error.tipo != null">
            <b-alert 
                show 
                variant="danger" 
                dismissible>
                {{ $t(error.tipo, {cuid: error.par}) }}
            </b-alert>
        </div>
        <div v-else class="alert alert-danger alert-dismissible" role="alert">
            {{ $t(error) }}
        </div>
    </div>

        <!-- <div class="alert alert-danger alert-dismissible" role="alert">
            {{ $t(error) }} /*/*/*/
        </div> -->

</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ErrorBanner',

    computed: {
        ...mapState(['error']),

    }
}
</script>